// extracted by mini-css-extract-plugin
export default {"container":"TabProductAssignerManual_container__yHtBN","customPhotoCell":"TabProductAssignerManual_customPhotoCell__dItM+"};